import { useEffect, useState } from "react";
import Autosuggest from "react-autosuggest";
import { useTranslation } from "react-i18next";
import AutoComplete from "../../../components/AutoComplete/AutoComplete";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import { technologyService } from "../../../services/TechnologyService";
import { toast } from "react-toastify";

export function CreateOrEdit(props) {
  const [title, setTitle] = useState();
  const [skill, setSkill] = useState({});
  const [errors, setErrors] = useState({});
  const { t } = useTranslation();
  const [technologies, setTechnologies] = useState([]);

  const [state, setState] = useState({
    value: "",
    suggestions: []
  });

  useEffect(() => {
    getSkillById();
  }, [props.skillId]);

  function closeModal() {
    props.close();
    setErrors({});
    setSkill({});
  }

  function createOrUpdate() {
    if (validate()) return;

    technologyService.createOrUpdate(skill).then((data) => {
      if (!data) {
        props.refresh();
        closeModal();
      }
    });

    let techSkill = props.skills
      .filter((x) => x.description === skill.description)
      .shift();
    if (!techSkill) {
      toast.success(t("Successfully saved"));
    }
  }

  function getTechnologies({ value }) {
    technologyService.searchTecnologies(value).then((data) => {
      setState({ ...state, suggestions: data });
    });
  }

  function getSkillById() {
    if (props.skillId) {
      setTitle(t("Edit Skill"));
      technologyService
        .getTechnologyById(props.skillId)
        .then((data) => setSkill(data));
    } else {
      setTitle(t("New Skill"));
    }
  }

  function onChange({ target }) {
    if (target.value) setSkill({ ...skill, [target.name]: target.value });
    else {
      setSkill({ ...skill, [target.name]: undefined });
    }
  }

  function validate() {
    let _errors = {};
    if (!skill.description)
      _errors.description = t("The field description is required.");

    setErrors(_errors);
    return Object.keys(_errors).length > 0;
  }

  function onChangeSkill({ target }) {
    setSkill({ ...skill, description: target.value, id: undefined });
  }
  function setTechnologie(technology) {
    let _skill = {
      description: technology.description,
      id: technology.id
    };
    setSkill(_skill);
  }
  return (
    <ModalContainer
      modalTitle={title}
      isOpen={props.open}
      closeModal={closeModal}
      submitButtonAction={createOrUpdate}
      cancelButtonTitle={t("Cancel")}
      cancelButtonAction={closeModal}
      submitButtonTitle={t("Done")}
      submitButtonType="button"
    >
      <div className="form-group">
        <div className="label-wrapper">
          <label className="label">{t("Name")}</label>
          <div className="error-msg">{errors.description}</div>
        </div>

        <Autosuggest
          suggestions={state.suggestions}
          onSuggestionsFetchRequested={getTechnologies}
          onSuggestionsClearRequested={() =>
            setState({ ...state, suggestions: [] })
          }
          onSuggestionSelected={(event, { suggestion, suggestionValue }) => {
            setTechnologie(suggestion);
          }}
          getSuggestionValue={(suggestion) => suggestion.description}
          renderSuggestion={(suggestion) => (
            <span key={suggestion.description}>{`${suggestion.category}${
              suggestion.subCategory ? "/" + suggestion.subCategory + "/" : ""
            }${suggestion.description}`}</span>
          )}
          inputProps={{
            onChange: onChangeSkill,
            value: skill.description || ""
          }}
          highlightFirstSuggestion={true}
        />
      </div>
    </ModalContainer>
  );
}
